(function () {
    console.log("Tabindex-Fixer geladen..."); // Zum Testen in der Browser-Konsole

    const fixFocus = () => {
        // Finde alle Elemente mit aria-hidden="true"
        const hiddenElements = document.querySelectorAll('[aria-hidden="true"]');

        hiddenElements.forEach(container => {
            // Finde alle Links, Buttons etc. innerhalb dieser versteckten Container
            const focusables = container.querySelectorAll('a, button, input, select, textarea, [tabindex="0"]');

            focusables.forEach(el => {
                if (el.getAttribute('tabindex') !== '-1') {
                    el.setAttribute('tabindex', '-1');
                    el.dataset.fixedAria = "true"; // Markierung zur Kontrolle
                }
            });
        });
    };

    // 1. Initial ausführen
    fixFocus();

    // 2. Dauerhafte Überwachung für Slider-Wechsel & dynamische Inhalte
    const observer = new MutationObserver(() => {
        fixFocus();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-hidden']
    });
})();